<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" >User Details</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page"  (click)="service.back()">Users</li>
                        </ol>
                    </nav>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
                <div class="col-xl-11">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-0 brand-color" >User Details</h5>
                            </div>
                            <hr>
                            <form  class="row">
                                <div class="col-md-12 pb-2" *ngIf="imgURL !='' ">
                                    <div class="form-label m-2" for="Username">Profile Image </div>
                                    <div class="file-upload-output">
                                        <img [src]="imgURL" alt="Admin" style="height:50px;width:50px" (click)="largeView =imgURL"    data-bs-toggle="modal" data-bs-target="#Image_view">
                                    </div>
                                </div>

                                <!-- <div class="col-md-12 pb-3" *ngIf="CurrentDetail.galleryImages.length !=0 ">
                                    <div class="form-label m-2" for="Username">Gallary Images </div>
                                    <div class="file-upload-output me-5" *ngFor="let ite of CurrentDetail.galleryImages">
                                        <img [src]="ite.image" alt="Admin" style="height:50px;width:50px" (click)="largeView =ite.image"    data-bs-toggle="modal" data-bs-target="#Image_view">
                                    </div>
                                </div> -->

                                 <div *ngIf="CurrentDetail.document !=''" >
                                    <h5>Annual Income Document</h5>
                                    <div class="d-flex" >
                                        <div class="col-md-2">                                    
                                            <div class="file-upload-output" *ngIf="CurrentDetail.document_type!='image'">
                                                <i class="bx bx-file me-5 ms-5" ></i>
                                                <i class="bx bx-download me-3" (click) = "download(CurrentDetail.document)"></i> 
                                            </div>
                                            <div class="file-upload-output" *ngIf="CurrentDetail.document_type=='image'">
                                                <img [src]="CurrentDetail.document" alt="Admin" style="height:50px;width:50px" (click)="largeView =CurrentDetail.document"    data-bs-toggle="modal" data-bs-target="#Image_view">

                                            </div>
                                        </div>
                                    </div>  
                                </div>                               
                                <div class="col-6 pt-4">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username">Full Name </label>
                                        <input type="text" class="form-control " id="Username" placeholder="First Name" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.fullName" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <!-- <div class="col-6 pt-4">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username">Last Name </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Last Name" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.lastName" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div> -->
                                <div class="col-6 pt-4">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Gender </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Gender" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.genders" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Email </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Email" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.email" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>                               
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Date of Birth  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Date of Birth" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.dob" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Age  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Age" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.age" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Phone Number </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Country" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.countryCode + ' '+ CurrentDetail.phoneNumber" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <!-- <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Country </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Country" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.countryData.name" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> City  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="City" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.cityData.name" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div> -->
                                <!-- <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Travel Prefrences  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Travel Prefrences" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.travelPreferenceDatas" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div> -->
                                <!-- <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Height  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Height" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.height" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>                          -->
                                <!-- <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Status </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Status" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.status" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>  -->
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Hair Type  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Hair Type" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.hairTypeData.hairType" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Eye Type  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Eye Type" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.eyeTypeData.eyeType" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Body Type  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Body Type" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.bodyTypeData.bodyType" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <!-- <div class="col-6" *ngIf="CurrentDetail.CountryDetail !=''">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Country Preference </label>
                                        <textarea type="text" class="form-control" rows="3"  id="Username" placeholder="Country Preference" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.CountryDetail" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div>  -->
                                <!-- <div class="col-6" *ngIf="CurrentDetail.CityDetail !=''">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> City Preference </label>
                                        <textarea type="text" class="form-control" rows="3"  id="Username" placeholder="City Preference" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.CityDetail" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div>  -->
                                <div class="col-6" *ngIf="CurrentDetail.interest_name !=''">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Interests </label>
                                        <textarea type="text" class="form-control" rows="3"  id="Username" placeholder="Interests" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.interest_name" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div> 
                                <div class="col-6" *ngIf="CurrentDetail.language_name !=''">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> Language </label>
                                        <textarea type="text" class="form-control" rows="1"  id="Username" placeholder="Language" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.language_name" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div> 
                                <div class="col-12" >
                                    <div class="form-group pb-4">
                                        <label class="form-label m-1" for="Username"> About </label>
                                        <textarea type="text" class="form-control" rows="3"  id="Username" placeholder="About" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.about" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div>  

                                <!-- <div class="col-12" *ngIf="CurrentDetail.socialMediaLink.length !=0">
                                    <div class="form-group pb-4">
                                        <div class="form-label m-0" for="Username" >Social Media Link</div>
                                        <div class="form-label m-0" for="Username" *ngIf=" CurrentDetail.socialMediaLink[0].facebook !=''">Facebook : {{ CurrentDetail.socialMediaLink[0].facebook}} </div>
                                        <div class="form-label m-0" for="Username" *ngIf=" CurrentDetail.socialMediaLink[1].instagram !=''">Instagram : {{ CurrentDetail.socialMediaLink[1].instagram}} </div>
                                    </div>
                                </div>                            -->
                                                     
                                <div class="btn-box col-12 pt-4">
                                    <button type="submit" class="btn custom-btn dark-btn px-4 me-3" (click)="service.back()">Back</button>
                                    <button type="button" class="btn custom-btn btn-success px-4 me-3" (click)="verifyAccount(CurrentDetail._id,'Approved')"   *ngIf="!CurrentDetail.isAnnualIncome">Approve</button>
                                    <button type="button" class="btn custom-btn btn-success px-4 me-3"   *ngIf="CurrentDetail.isAnnualIncome">Approved</button>
                                    <button type="button" class="btn custom-btn btn-danger px-4 me-3" (click)="verifyAccount(CurrentDetail._id,'Rejected')"  *ngIf="!CurrentDetail.isAnnualIncome">Reject</button>
                                    <!-- <button type="button" class="btn custom-btn btn-danger px-4 me-3" *ngIf="!CurrentDetail.isAnnualIncome">Rejected</button> -->


                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card">
                        <div class="col-12 col-xl-11">
                            <div class="accordion-block">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item darksecundary-bg" *ngIf="socialDetail.length !=0">
                                        <h2 class="accordion-header" id="Social_Heading">
                                            <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#Social_Information" aria-expanded="true" aria-controls="Social_Information">
                                        Social Tendency
                                    </button>
                                        </h2>
                                        <div id="Social_Information" class="accordion-collapse collapse show" aria-labelledby="Social_Heading">
                                            <div class="accordion-body custom-form custom-form-2">
                                                <div class="card-body  table-responsive">
                                                    <table class="table mb-0 table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">No.</th>                                       
                                                                <th scope="col" >Question</th>
                                                                <th scope="col" >Answer</th>  
                                                                <th scope="col">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody *ngIf="socialDetail.length !=0">
                                                            <tr *ngFor="let item of socialDetail ; let i = index ">
                                                                <td scope="row">{{ i + 1 }}</td>
                                                                <td>{{item.question}}</td>
                                                                <td >{{item.answer}}</td>
                                                                <td>
                                                                    <span class="badge bg-success">{{item.status}}</span>
                                                                </td>                                                                               
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="socialDetail.length ==0">
                                                            <tr>
                                                                <p class="text-center">Sorry, No Record Found</p>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item darksecundary-bg" *ngIf="MatchDetail.length !=0">
                                        <h2 class="accordion-header" id="Prefer_Heading">
                                            <button class="accordion-button collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#PreferDescrepstion" aria-expanded="false" aria-controls="PreferDescrepstion">
                                               Matches Detail
                                            </button>
                                        </h2>
                                        <div id="PreferDescrepstion" class="accordion-collapse collapse show" aria-labelledby="Prefer_Heading">
                                            <div class="accordion-body custom-form custom-form-2">
                                                <div class="card-body  table-responsive">
                                                    <table class="table mb-0 table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">No.</th>                                       
                                                                <!-- <th scope="col">Image</th> -->
                                                                <th scope="col">Username</th>  
                                                            </tr>
                                                        </thead>
                                                        <tbody *ngIf="MatchDetail.length !=0">
                                                            <tr *ngFor="let item of MatchDetail ; let i = index ">
                                                                <td scope="row">{{ i + 1 }}</td>                                                                
                                                                <!-- <td ><img [src]="item.answer" style="height: 40px; width:40px"></td> -->
                                                                <td>{{item.matchData.userName}}</td>                                                                           
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="MatchDetail.length ==0">
                                                            <tr>
                                                                <p class="text-center">Sorry, No Record Found</p>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item darksecundary-bg" *ngIf="emojiDetail.length !=0">
                                        <h2 class="accordion-header" id="Emoji_Heading">
                                            <button class="accordion-button collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#EmojiDescrepstion" aria-expanded="false" aria-controls="EmojiDescrepstion">
                                                Emoticons
                                            </button>
                                        </h2>
                                        <div id="EmojiDescrepstion" class="accordion-collapse collapse show" aria-labelledby="Emoji_Heading">
                                            <div class="accordion-body custom-form custom-form-2">
                                                <div class="card-body  table-responsive">
                                                    <table class="table mb-0 table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">No.</th>                                       
                                                                <th scope="col" >Question</th>
                                                                <th scope="col" >Answer</th>  
                                                                <th scope="col">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody *ngIf="emojiDetail.length !=0">
                                                            <tr *ngFor="let item of emojiDetail ; let i = index ">
                                                                <td scope="row">{{ i + 1 }}</td>
                                                                <td>{{item.question}}</td>
                                                                <td ><img [src]="item.answer" style="height: 40px; width:40px"></td>
                                                                <td>
                                                                    <span class="badge bg-success">{{item.status}}</span>
                                                                </td>                                                                               
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="emojiDetail.length ==0">
                                                            <tr>
                                                                <p class="text-center">Sorry, No Record Found</p>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </div>                      
                            </div>
                        </div>
                    </div>
            <!--end row-->

                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>


<div class="modal fade" id="Image_view" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Image_view')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="mt-4 p-4 white-bg qr-code-img">
                        <img id="qr_code" loading="lazy" class="w-100" [src]="largeView" />
                    </div>
                </div>
              
            </div>
           
        </div>
    </div>
</div>

<div class="modal fade" id="Video_view" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Video_view')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="file-upload-output">
                        <video [src]="largeView"  controls disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*"  ></video>
                    </div>
                    <!-- <div class="mt-4 p-4 white-bg qr-code-img">
                        <img id="qr_code" loading="lazy" class="w-100" [src]="largeView" />
                    </div> -->
                </div>
              
            </div>
            
        </div>
    </div>
</div>
